import { Product } from "../../../../data/entities";
import { TableRow } from "@mui/material";
import { StyledTableCell } from "../../../../shared/components/CustomTable/Styled";
import {
    ProductFilterType,
    valueToText,
} from "../../../../configs/filterTypes";
import Status from "../../../../shared/components/Status";
import StatusActive from "../../../../shared/components/StatusActive";
import { PRODUCT_CATEGORY, ROLE } from "../../../../data/enums";
import { StyledNavLink, StyledNavLinkNewTab } from "../../../../shared/styled/TableStyles";
import { useContext } from "react";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";

const getCategoryColorTheme = (category: string) => {
    switch (category) {
        case PRODUCT_CATEGORY.BARREL:
            return "SUCCESS";
        case PRODUCT_CATEGORY.VESSEL:
            return "WARNING";
        case PRODUCT_CATEGORY.VEHICLE:
            return "INFO";
        default:
            return "INFO";
    }
};

export const ProductRow = ({ item }: { item: Product }) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const isActive = Boolean(item.is_active);

    return (
        <TableRow>
            <StyledTableCell align="left">
                <StyledNavLinkNewTab 
                    href={`/products/${item.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {item.product_code && item.product_code.trim() !== ""
                        ? item.product_code
                        : item.id}
                </StyledNavLinkNewTab>
            </StyledTableCell>
            <StyledTableCell align="left">{item.name}</StyledTableCell>
            <StyledTableCell align="left">
                <Status
                    colorTheme={getCategoryColorTheme(item.category)}
                    text={valueToText(
                        ProductFilterType,
                        "category",
                        item.category
                    )}
                    width="96px"
                />
            </StyledTableCell>
            <StyledTableCell align="left">
                {item.category_group ? item.category_group.name : ""}
            </StyledTableCell>
            {(role !== ROLE.FIRST_STORAGE_KEEPER && role !== ROLE.SECOND_STORAGE_KEEPER) && (
                <StyledTableCell align="left">
                    {item.storage}
                </StyledTableCell>
            )}
            <StyledTableCell align="left">
                <StatusActive isActive={isActive} />
            </StyledTableCell>
            <StyledTableCell align="left">{item.quantity}</StyledTableCell>
        </TableRow>
    );
};
